"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.couponValue = exports.couponDeserialize = void 0;
const max_1 = __importDefault(require("lodash/max"));
const round_1 = __importDefault(require("lodash/round"));
const expect_1 = __importDefault(require("../util/expect"));
const unwrap_1 = __importDefault(require("../util/unwrap"));
const deserializeNumber_1 = require("./deserializeNumber");
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializeString_1 = require("./deserializeString");
function couponDeserialize(value, id) {
    const object = (0, deserializeObject_1.default)(value, 'coupon');
    return {
        id: (0, deserializeString_1.deserializeString)(id),
        flatRate: (0, unwrap_1.default)(object.flatRate, deserializeNumber_1.deserializeNumber),
        discountAmount: (0, unwrap_1.default)(object.discountAmount, deserializeNumber_1.deserializeNumber),
        discountFraction: (0, unwrap_1.default)(object.discountFraction, deserializeNumber_1.deserializeNumber),
        expirationTimestampMilliseconds: (0, unwrap_1.default)(object.expirationTimestampMilliseconds, deserializeNumber_1.deserializeNumber),
    };
}
exports.couponDeserialize = couponDeserialize;
// ------------------------------------------------------------------------------------------------------------ //
// value
function couponValue(coupon, valueBeforeDiscountD) {
    let discountByAmountD = 0;
    let discountByFlatRateD = 0;
    let discountByFractionD = 0;
    // by amount
    (0, unwrap_1.default)(coupon.discountAmount, amountC => {
        discountByAmountD = valueBeforeDiscountD - amountC / 100;
        discountByAmountD = (0, round_1.default)(discountByAmountD, 2);
        discountByAmountD = (0, expect_1.default)((0, max_1.default)([discountByAmountD, 0]));
    });
    // by flat rate
    (0, unwrap_1.default)(coupon.flatRate, rateC => {
        discountByFlatRateD = rateC / 100;
        discountByFlatRateD = (0, round_1.default)(discountByFlatRateD, 2);
        discountByFlatRateD = (0, expect_1.default)((0, max_1.default)([discountByFlatRateD, 0]));
    });
    // by fraction
    (0, unwrap_1.default)(coupon.discountFraction, fraction => {
        if (fraction <= 0 || fraction > 1) {
            throw new Error('Fraction must be greater than zero and less than one');
        }
        discountByFractionD = valueBeforeDiscountD - valueBeforeDiscountD * fraction;
        discountByFractionD = (0, round_1.default)(discountByFractionD, 2);
    });
    // max of the three amounts
    return (0, expect_1.default)((0, max_1.default)([discountByAmountD, discountByFlatRateD, discountByFractionD]));
}
exports.couponValue = couponValue;
